import { useGlobal } from '@/utils/useGlobal';
import EFPicture from 'elem/compCommon/EFPicture';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

export default function L() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_220w_double');
    // const [active, setActive] = useState(0);
    // const [swiper, setSwiper] = useState(null);

    const arr = [
        {
            img: '/responsive/picture/solar-panel-220w-double/10_1_768.jpg',
        },
        {
            img:
                locale === 'mx'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1747101993994/220_M_2.jpg'
                    : locale === 'br'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1742974700440/IP68.png'
                    : locale === 'kr'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1747293929563/M%20MX%20NextGen%20220W%2002-2.png'
                    : `/responsive/picture/solar-panel-220w-double/10_2_768_${locale}.jpg`,
        },
    ];

    const getImagePath = (locale: string) => {
        const imageMap = {
            mx: 'https://websiteoss.ecoflow.com/upload/image/1747033620923/220w.jpg',
            br: 'https://websiteoss.ecoflow.com/upload/image/1742365191956/220w.png',
            kr: 'https://websiteoss.ecoflow.com/upload/image/1747295957100/PC%20MX%20NextGen%20220W%2002.jpg',
        };

        return imageMap[locale] || `/responsive/picture/solar-panel-220w-double/10_${locale}.jpg`;
    };

    return (
        <div className="sp-220-double-L">
            <div className="info-box">
                <p className="title">{t('L_title')}</p>
                <p className="desc">{t('L_desc')}</p>
            </div>
            <div className="img-box pc">
                <EFPicture src={getImagePath(locale)} alt={t('L_title')} />
            </div>
            <Swiper
                className={`swiper-box h5`}
                modules={[Pagination]}
                spaceBetween={0}
                slidesPerView={'auto'}
                initialSlide={0}
                pagination={true}
                // onSlideChange={(swiper) => setActive(swiper?.activeIndex || 0)}
                // onSwiper={(swiperIns: any) => setSwiper(swiperIns)}
            >
                {arr?.map((item: any, k: number) => (
                    <SwiperSlide className="swiper-item" key={k}>
                        <EFPicture src={item.img} alt={t('L_title')} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
